import React, { Fragment, useEffect, useState } from 'react';
import * as S from './Styles';
export interface TabItem {
  label?: string;
  children?: JSX.Element;
}

export interface TabsProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  items: TabItem[];
  tab?: number;
  setTab?: (tab: number) => void;
  tags?: JSX.Element[];
  minHeight?: React.CSSProperties['minHeight'];
  maxHeight?: React.CSSProperties['maxHeight'];
  style?: React.CSSProperties;
}

const Tabs = ({
  items = [],
  children,
  tags,
  tab: t,
  setTab: st,
  style,
  minHeight = '72vh',
  maxHeight = '72vh',
}: TabsProps) => {
  const [tab, setTab] = useState(t ?? 0);
  useEffect(() => {
    st && st(tab);
  }, [tab]);
  return (
    <S.TabContainer style={style}>
      <S.TabsHeader>
        {items.map(({ label }, index) => (
          <Fragment key={index}>
            <S.TabControl
              id={`${index}`}
              checked={index === tab}
              onChange={(e) => {
                e.target.checked === true && setTab(index);
              }}
            />

            <S.Label htmlFor={`${index}`}>{label ?? ''}</S.Label>
          </Fragment>
        ))}
        {tags ? <S.TabTags>{tags}</S.TabTags> : null}
        {children}
      </S.TabsHeader>

      <S.ItemsContainer
        minHeight={minHeight}
        maxHeight={maxHeight}
        $selectedTab={tab}
      >
        {items.map(({ children }, index) => (
          <S.ItemChildren
            key={index}
            style={{
              display: index === tab ? 'block' : 'hidden',
              visibility: index === tab ? 'visible' : 'hidden',
              position: index === tab ? 'unset' : 'fixed',
            }}
          >
            {index === tab ? children : null}
          </S.ItemChildren>
        ))}
      </S.ItemsContainer>
    </S.TabContainer>
  );
};

export default Tabs;
